// extracted by mini-css-extract-plugin
export default {"sephoraIcon":"fga-z"};